const eventsSelector = (state) => ((state.app.event || {})[state.currentServiceProvider.id] || {}).new_message;

export default eventsSelector;
